// The Hethera logo. With `wordmark` (the default) it's the "Hethera"
// wordmark, where the mark is the H; `size` is its height. Without it, it's
// the app icon (the mark on the dark green tile); `size` is its side, and at
// 48 px and below it uses the small cut. Files come from the website repo's
// brand/ kit (public/static/img/hethera-*.svg).

type Props = {
  size?: number;
  wordmark?: boolean;
  /** 'dark' = on a dark background (lime H, white letters). */
  tone?: 'light' | 'dark';
};

const HetheraLogo = ({ size = 34, wordmark = true, tone = 'light' }: Props) => {
  if (wordmark) {
    const file = tone === 'dark' ? 'hethera-wordmark-on-dark.svg' : 'hethera-wordmark.svg';
    return <img src={`/static/img/${file}`} height={size} alt='Hethera' style={{ display: 'block' }} />;
  }
  const src = size <= 48 ? '/static/img/hethera-icon-small.svg' : '/static/img/hethera-icon.svg';
  return <img src={src} width={size} height={size} alt='Hethera' style={{ display: 'block' }} />;
};

export default HetheraLogo;
